import { AxiosError, AxiosResponse } from 'axios'
import { NextApiResponse } from 'next'
import { Stream } from 'node:stream'

export async function makeSafeRequest<T>(requestFunction: () => Promise<T>) {
  try {
    const data = await requestFunction()
    return { data }
  } catch (error: unknown) {
    return { error: error as AxiosError }
  }
}

export const handleStream = (response: NextApiResponse) => (axiosResponse: AxiosResponse<Stream>) => {
  if ('set-cookie' in axiosResponse.headers) {
    response.setHeader('set-cookie', String(axiosResponse.headers['set-cookie']))
  }
  axiosResponse.data.pipe(response)
}
